export default {
  AB_TEST: 'abTest',
  PAGE: 'page',
  PAGE_INFO: 'pageInfo',
  PAGE_TYPE: 'pageType',
  PAGE_NAME: 'pageName',
  PAGE_LOAD_EVENT: 'pageLoadEvent',
  CATEGORY: 'category',
  PRIMARY_CATEGORY: 'primaryCategory',
  SUB_CATEGORY1: 'subCategory1',
  SUB_CATEGORY2: 'subCategory2',
  EVENT: 'event',
  EVENT_INFO: 'eventInfo',
  EVENT_NAME: 'eventName',
  EVENT_MODE: 'eventMode',
  ERROR: 'error',
  ERROR_TYPE: 'errorType',
  SETTINGS: 'settings',
  MY_ACCOUNT: 'myAccount',
  STASH: 'stash',
  TYPE: 'type',
  DISPLAY_TYPE: 'displayType',
  PAGE_SECTION: 'pageSection',
  MESSAGE: 'message',
  ERROR_MESSAGE: 'errorMessage',
  CODE: 'code',
};
